// Sort by name only, in Vietnamese order, so filtering by region keeps it A-Z
const sortProvinces = (provinces) =>
  [...(provinces || [])].sort((a, b) => a.name.localeCompare(b.name, 'vi'));

export { sortProvinces };
